import React from 'react';
import Form from '@components/dynamic-form/Form';
import { permitProcessGuideForm } from './permit-process-guide-data/permitProcessGuideData';
import { QuestionSectionData, QuestionDataById } from '@components/dynamic-form/types';

type FormData = {
  formId: number | string;
  formTitle: string;
  isInformation?: boolean;
  subtitle?: string;
  regionHeader?: string;
  sections: QuestionSectionData[];
  questionsById: QuestionDataById;
};

type PermitProcessQuestionnaireProps = {
  formData: FormData;
};

const PermitProcessQuestionnaire: React.FC<PermitProcessQuestionnaireProps> = () => {
  return (
    <Form
      allowAutoScroll={false}
      componentID='NOT_SURE'
      formData={permitProcessGuideForm}
      isInformation={false}
      isReadOnly={false}
      showErrorSummary={false}
      stepNo={1}
    />
  );
};
export default PermitProcessQuestionnaire;
